import {useCallback, useEffect, useRef, useState} from "react";
import DatePicker from "react-datepicker";
import {Button} from "react-bootstrap";
import { AppCheckbox } from "../components/form";
import FilterOrder from "../components/FilterOrder/FilterOrder";
import InputGroup from 'react-bootstrap/InputGroup';
import ManagerAccordion from "../components/ManagerAccordion/ManagerAccordion";
import ManagerTable from "../components/ManagerTable/ManagerTable";

export const Dashboard = () => {

    const [orders, setOrders] = useState([{}])
    const [dataFB, setDataFB] = useState([])
    const [source, setSource] = useState('all')
    const [manager, setManager] = useState('all')
    const [rangeDate, setRangeDate] = useState('day')
    const [timeLastUpdated, setTimeLastUpdated] = useState('')
    const [eveningShiftHours, setEveningShiftHours] = useState(false)
    const [dataMessages, setDataMessages] = useState([]);
    const [leads, setLeads] = useState({}); // Храним лиды для каждого менеджера
    const [planCompleted, setPlanCompleted] = useState(false);

    const handleLeadsChange = (managerId, value) => {
        setLeads(prevLeads => ({
            ...prevLeads,
            [managerId]: value
        }));
    };


    const [range, setRange] = useState({
        startDate: new Date(),
        endDate: new Date()
    });
    const [isLoading, setLoading] = useState(false);
    const [isLoadingY, setLoadingY] = useState(false);
    const [isLoadingS, setLoadingS] = useState(false);
    const [isLoadingCM, setLoadingCM] = useState(false);
    const [isLoadingPM, setLoadingPM] = useState(false);
    const [isLoadingT, setLoadingT] = useState(false);
    const [isUploadData, setUploadData] = useState(false);
    const [hideMargin, setHideMargin] = useState(true);

    const exchangeRate = 42;
    const { ClipboardItem } = window;

    Date.prototype.getWeek = function() {
        const onejan = new Date(this.getFullYear(),0,1);
        const today = new Date(this.getFullYear(),this.getMonth(),this.getDate());
        const dayOfYear = ((today - onejan)/86400000);
        return Math.ceil(dayOfYear/7)
    };
    Date.prototype.get2Weeks = function() {
        const onejan = new Date(this.getFullYear(),0,1);
        const today = new Date(this.getFullYear(),this.getMonth(),this.getDate());
        const dayOfYear = ((today - onejan)/86400000);
        return Math.ceil(dayOfYear/14)
    };

    const multiSearchAtLeastN = (text, searchWords, minimumMatches) => {
        let matches = 0;
        for (let word of searchWords.split(",")) {
            if (text.join(" ").includes(word) && ++matches >= minimumMatches) return true;
        }
        return false;
    };
    function sortProducts(a,b){
        a = a.quantity
        b = b.quantity
        if(a>b) return -1;
        if(a<b) return 1;
        return 0;
    }
    function sortHeaderUploadData(a,b){
        a = a.payback
        b = b.payback
        if(a>b) return -1;
        if(a<b) return 1;
        return 0;
    }

    function getDates(startDate, endDate, interval) {
        const duration = endDate - startDate;
        const steps = duration / interval;
        const dates = Array.from({length: steps+1}, (v,i) => new Date(startDate.valueOf() + (interval * i)))
        return dates.map((date)=> {
            const year = date.toLocaleString("default", { year: "numeric" });
            const month = date.toLocaleString("default", { month: "2-digit" });
            const day = date.toLocaleString("default", { day: "2-digit" });
            return year + "-" + month + "-" + day;
        });
    }

    function sortNames(a,b){
        a = a.name
        b = b.name
        if(a>b) return -1;
        if(a<b) return 1;
        return 0;
    }

    const getCustomNames = (arr, prop1, prop2) => {
        const arr1 = arr.map((item) => {
            // if(item.name.includes("-")) {
            //     item.name = item.name.split("-")[0]
            //     console.log("item.name", item.name)
            // }
            const name = item.name
            if(name.includes("Комплект білизни")) item.name = "Комплект білизни"
            if(name === "Футболка Двонитка" || name === "Футболка двонитка") item.name = "Футболка"
            if(name === "Лонгслів Amour Toujours"
                || name === "Лонгслів Gluten morgen"
                || name === "Лонгслів Chatting&drinking") item.name = "Лонгслів з друком"
            if(name === "Футболка Gluten morgen"
                || name === "Футболка Bla bla bla"
                || name === "Футболка Chatting&drinking"
                || name === "Футболка Quiet place"
                || name === "Футболка Kiss me"
                || name === "Футболка Amour Toujours"
                || name === "Футболка Amaze me") item.name = "Футболка з друком"
            if(name === "Футболка Mom says"
                || name === "Футболка Fantasies"
                || name === "Футболка Fall in love") item.name = "Футболка з вишивкою"
            if(name.includes("Зіпхуді петля")) item.name = "Зіпхуді петля"
            if(name.includes("Піжама зі штанами")) item.name = "Піжама з штанами"
            if(name === "Спідниця") item.name = "Спідниця з паєтками"
            if(name === "Піжама в смужку") item.name = "Піжама з кантом"
            if(name.includes("Джогери петля") || name.includes("Джогери чоловічі")) item.name = "Джогери петля"
            if(name.includes("Шорти льон 2023") || name.includes("Шорти короткі")) item.name = "Шорти короткі"
            if(name.includes("Худі петля")) item.name = "Худі петля"
            if(name.includes("Світшот петля")) item.name = "Світшот петля"
            if(name.includes("Палаццо зі шлейками") || name === "Палаццо з поясом") item.name = "Палаццо"
            if(name.includes("Гольф")) item.name = "Гольф"
            if(name.includes("Лонгслів оверсайз")) item.name = "Лонгслів Оверсайз"
            if(name.includes("Купальник")) item.name = "Купальник"
            if(name === "Майка" || name.includes("Майка з кантом")) item.name = "Майка"
            if(name === "Карго" || name === "Карго 2023") item.name = "Карго"
            if(name === "Штани з еко-шкіри з принтом") item.name = "Брюки з екошкіри"
            if(name === "Пуфер зимовий") item.name = "Пуховик"
            if(name === "Джогери з флісу") item.name = "Джогери Фліс"
            if(name === "Лонгслів") item.name = "Лонгслів двонить"
            if(name === "Худі Фліс" || name.includes("Худі чоловічі Фліс")) item.name = "Худі Фліс"
            if(name === "Топ" || name === "Топ new" || name === "Топ new з чашечками" || name === "Труси new" || name === "Труси" || name === "Топ з чашечками") item.name = "Топ чи Труси окремо"
            if(name === "Труси Мустанг" || name === "Труси кенді" || name === "Труси SEX&CANDY") item.name = "Труси нові"
            return item
        });

        function getResult(arr) {
            let objProp1 = {};
            let objProp2 = {};

            arr.forEach(function(d) {
                if (objProp1.hasOwnProperty(d.name)) {
                    objProp1[d.name] = objProp1[d.name] + d[`${prop1}`];
                } else {
                    objProp1[d.name] = d[`${prop1}`];
                }
            });
            prop2 && arr.forEach(function(d) {
                if (objProp2.hasOwnProperty(d.name)) {
                    objProp2[d.name] = objProp2[d.name] + d[`${prop2}`];
                } else {
                    objProp2[d.name] = d[`${prop2}`];
                }
            });

            let result = [];

            for (let p1 in objProp1) {
                if(Object.keys(objProp2).length !== 0) {
                    for (let p2 in objProp2) {
                        p1 === p2 && result.push({ name: p1, [`${prop1}`]: objProp1[p1], [`${prop2}`]: objProp2[p2] })
                    }
                } else {
                    result.push({ name: p1, [`${prop1}`]: objProp1[p1]})
                }
            }

            // console.log(result);
            return result
        }

        return  getResult(arr1)
    }
    const getStringDateUTC = stringDate => {
        const date = new Date(stringDate);
        const h = date.getUTCHours()
        const hh = h <= 9 ? '0' + h : h;
        const m = date.getUTCMinutes()
        const mm = m <= 9 ? '0' + m : m;
        const s = date.getUTCSeconds()
        const ss = s <= 9 ? '0' + s : s;
        const year = date.getUTCFullYear()
        let month = date.getUTCMonth() + 1
        month = month <= 9 ? '0' + month : month;
        let day = date.getUTCDate()
        day = day <= 9 ? '0' + day : day;
        return  year + "-" + month + "-" + day + " " + hh + ":" + mm + ":" + ss
    }
    const filterPrevDay = getPreviousDay()
    const filterCM = getCurrrentMonth()
    const filterPM = getPrevMonth()

    //*** This code is copyright 2002-2016 by Gavin Kistner, !@phrogz.net
    //*** It is covered under the license viewable at http://phrogz.net/JS/_ReuseLicense.txt
    Date.prototype.customFormat = function(formatString){
        var YYYY,YY,MMMM,MMM,MM,M,DDDD,DDD,DD,D,hhhh,hhh,hh,h,mm,m,ss,s,ampm,AMPM,dMod,th;
        YY = ((YYYY=this.getFullYear())+"").slice(-2);
        MM = (M=this.getMonth()+1)<10?('0'+M):M;
        MMM = (MMMM=["January","February","March","April","May","June","July","August","September","October","November","December"][M-1]).substring(0,3);
        DD = (D=this.getDate())<10?('0'+D):D;
        DDD = (DDDD=["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"][this.getDay()]).substring(0,3);
        th=(D>=10&&D<=20)?'th':((dMod=D%10)===1)?'st':(dMod===2)?'nd':(dMod===3)?'rd':'th';
        formatString = formatString.replace("#YYYY#",YYYY).replace("#YY#",YY).replace("#MMMM#",MMMM).replace("#MMM#",MMM).replace("#MM#",MM).replace("#M#",M).replace("#DDDD#",DDDD).replace("#DDD#",DDD).replace("#DD#",DD).replace("#D#",D).replace("#th#",th);
        h=(hhh=this.getHours());
        if (h===0) h=24;
        if (h>12) h-=12;
        hh = h<10?('0'+h):h;
        hhhh = hhh<10?('0'+hhh):hhh;
        AMPM=(ampm=hhh<12?'am':'pm').toUpperCase();
        mm=(m=this.getMinutes())<10?('0'+m):m;
        ss=(s=this.getSeconds())<10?('0'+s):s;
        return formatString.replace("#hhhh#",hhhh).replace("#hhh#",hhh).replace("#hh#",hh).replace("#h#",h).replace("#mm#",mm).replace("#m#",m).replace("#ss#",ss).replace("#s#",s).replace("#ampm#",ampm).replace("#AMPM#",AMPM);
    };
    function getFormattedDate(date, time = "00:00:00") {
        const year = date.toLocaleString("default", { year: "numeric" });
        const month = date.toLocaleString("default", { month: "2-digit" });
        const day = date.toLocaleString("default", { day: "2-digit" });
        return `${year}-${month}-${day} ${time}`;
    }

    function getUTCFormattedDate(dateFormat) {
        return getStringDateUTC(dateFormat); // Предполагается, что getStringDateUTC() уже работает как нужно.
    }

    function getFilterForPeriod(startDate, endDate) {
        const startDateFormatted = getFormattedDate(startDate, "00:00:00");
        const endDateFormatted = getFormattedDate(endDate, "23:59:59");
        const startDateUTCFormatted = getUTCFormattedDate(startDateFormatted);
        const endDateUTCFormatted = getUTCFormattedDate(endDateFormatted);
        return encodeURIComponent("filter[created_between]") + "=" + encodeURIComponent(startDateUTCFormatted + ", " + endDateUTCFormatted);
    }

    function getCurrrentMonth(date_today = new Date()) {
        const firstDay = new Date(date_today.getFullYear(), date_today.getMonth(), 1);
        const lastDay = new Date(date_today.getFullYear(), date_today.getMonth() + 1, 0);
        return getFilterForPeriod(firstDay, lastDay);
    }

    function getPrevMonth(date_today = new Date()) {
        const firstDay = new Date(date_today.getFullYear(), date_today.getMonth() - 1, 1);
        const lastDay = new Date(date_today.getFullYear(), date_today.getMonth(), 0);
        return getFilterForPeriod(firstDay, lastDay);
    }

    function getPreviousDay(date = new Date()) {
        const previous = new Date(date.getTime());
        previous.setDate(date.getDate() - 1);
        return getFilterForPeriod(previous, previous);
    }


    const getStartYear = range.startDate.toLocaleString("default", { year: "numeric" });
    const getStartMonth = range.startDate.toLocaleString("default", { month: "2-digit" });
    const getStartDay = range.startDate.toLocaleString("default", { day: "2-digit" });
    const getStartTime = eveningShiftHours ? "21:00:00" : "00:00:00";
    let startDateFormat = getStartYear + "-" + getStartMonth + "-" + getStartDay + " " + getStartTime;
    const startDateUTCFormatted = getStringDateUTC(startDateFormat)

    const getEndYear = range.endDate.toLocaleString("default", { year: "numeric" });
    const getEndMonth = range.endDate.toLocaleString("default", { month: "2-digit" });
    const getEndDay = range.endDate.toLocaleString("default", { day: "2-digit" });
    const getEndTime = "23:59:59"
    const endDateFormat = getEndYear + "-" + getEndMonth + "-" + getEndDay + " " + getEndTime;
    const endDateUTCFormatted = getStringDateUTC(endDateFormat)

    const limit = "limit=50"
    const sort = "sort=id"
    const filter = encodeURIComponent("filter[created_between]") + "=" + encodeURIComponent(startDateUTCFormatted + ", " + endDateUTCFormatted)
    const includes = "include=" + encodeURIComponent("manager, status, payments, products.offer, tags")

    const parameters = [limit, sort, filter, includes].join("&")

    const startDateFB = encodeURIComponent(getStartYear + "-" + getStartMonth + "-" + getStartDay)
    const untilDateFB = encodeURIComponent(getEndYear + "-" + getEndMonth + "-" + getEndDay)

    function fetchDataFB(date, source) {
        const parameters = "time_range=%7B%22since%22%3A%22" + date + "%22%2C%22until%22%3A%22" + date + "%22%7D&limit=100&level=campaign&fields=campaign_id,campaign_name,clicks,impressions,spend,cpc,cpm,ctr,reach"
        return fetch(`/api/ads?${parameters}&source=${source}`)
    }

    const startTime = range.startDate.setHours(9,0,0,0)
    const nowTime = new Date()
    const time = Math.abs(nowTime - startTime)
    const hours = (time/(1000*60*60)).toFixed(1)
    const hours24 = Math.floor(hours/24)
    const workHours = hours - 9*hours24
    // console.log(workHours)

    const fetchDataMessages = useCallback(async () => {
        const response = await fetch('/api/messages/');
        const data = await response.json()
        console.log("fetchDataMessages:", data)
        setDataMessages(data);
    }, [])

    useEffect(() => {
        const fetchData = (parameters) => {
            console.log("> start fetchData")
            fetch(`/api/orders?${parameters}`).then(response => {
                if (!response.ok) {
                    console.error(`Помилка завантаження ${response.status}`)
                    if (response.status === 500) {
                        alert("Занадто часто, спробуйте пізніше")
                        throw new Error('Something went wrong.');
                    }
                }
                setLoading(false)
                setLoadingT(false)
                setLoadingY(false)
                setLoadingS(false)
                setLoadingCM(false)
                setLoadingPM(false)
                return  response.json()
            }).then(data => {
                setOrders(data)
            }).catch(function(error) {
                console.log('Request failed', error);
            });
        }
        async function getData(source) {
            const start = new Date(startDateFB)
            const end = new Date(untilDateFB)
            const dayInterval = 1000 * 60 * 60 * 24; // 1 day
            const dates = getDates(start, end, dayInterval)

            const promises = dates.map(date => {
                return fetchDataFB(date, source);
            })
            const responses = await Promise.all(promises);
            const jsonData = await Promise.all(responses.map((r) => r.json()));

            const result = []
            dates.forEach((date, d) => {
                jsonData.forEach((item, i) => {
                    if (d === i) {
                        result.push({ads: item, date: date})
                    }
                })
            })
            setDataFB(result);
        };
        fetchData(parameters)
        isUploadData && getData(source).then()
        const now = new Date();
        var myString = now.customFormat("#hhh#:#mm#:#ss#");
        setTimeLastUpdated(myString)
    }, [isLoading, isLoadingT, isLoadingY, isLoadingCM, isLoadingPM]);

    useEffect(() => {

        const interval = setInterval(() => {
            addDataToDB(parametersCurrentMonth)
            console.log("================UPDATE DB================")
        }, 300000)
        return () => clearInterval(interval)
    }, []);

    useEffect(() => {
        fetchDataMessages().then()
    }, []);

    const getSourceReturns = (order, source) => {
        const isOrderReturns = order.status.id === 20 || order.status.id === 21 || order.status.id === 39
        if (isOrderReturns) return source.returns = source.returns + 1
        else return source.returns
    }
    const getSourceGrandTotal = (order, source) => {
        return source.grandTotal = +(Math.floor(source.grandTotal + order.grand_total)).toFixed(0)
    }
    const getSourceSales = (order, source) => {
        source.sales = order.status.id !== 39 ? source.sales + 1 : source.sales
        return source.sales
    }

    const getObjDataSource = (order, source) => {
        return {
            returns: getSourceReturns(order, source),
            grandTotal: getSourceGrandTotal(order, source),
            quantitySales: getSourceSales(order, source)
        }
    }
    const getDataSource = (order, source, source_id, source_id2) => {
        return order.source_id === source_id || order.source_id === source_id2 ? {...source, ...getObjDataSource(order, source)} : source
    }

    function runAtSpecificTimeOfDay(hour, minutes, func) {
        const twentyFourHours = 86400000;
        const now = new Date();
        let eta_ms = new Date(now.getFullYear(), now.getMonth(), now.getDate(), hour, minutes, 0, 0).getTime() - now;
        if (eta_ms < 0)
        {
            eta_ms += twentyFourHours;
        }
        setTimeout(function() {
            //run once
            func();
            // run every 24 hours from now on
            setInterval(func, twentyFourHours);
        }, eta_ms);
    }

    const handleClickSalary = () => {
        return setLoadingS(true)
    }

    const handleClickCreate = () => setLoading(true);
    const handleClickYestarday = () => {
        const yesterday = new Date()
        yesterday.setDate(yesterday.getDate() - 1)
        setRange(prevRange => ({ ...prevRange, startDate : yesterday }))
        setRange(prevRange => ({ ...prevRange, endDate : yesterday }))
        return setLoadingY(true)
    };
    const handleClickToday = () => {
        const today = new Date()
        setRange(prevRange => ({ ...prevRange, startDate : today }))
        setRange(prevRange => ({ ...prevRange, endDate : today }))
        return setLoadingT(true)
    };


    const parametersDB = [limit, sort, filter, includes].join("&")
    const parametersPrevDay = [limit, sort, filterPrevDay, includes].join("&")
    const parametersPrevMonth = [limit, sort, filterPM, includes].join("&")
    const parametersCurrentMonth = [limit, sort, filterCM, includes].join("&")

    const fetchDataForDB = async (parameters) => {
        const response = await fetch(`/api/orders?${parameters}`)
        return response.json()
    }

    let arrManagers = []
    let arrSources = []
    let arrSources11 = []
    let arrRanges = ["day", "week", "2weeks", "month", "year"]

    orders.forEach(order => {
        if (Object.keys(order).length !== 0 && !arrManagers.length) return arrManagers.push(order.manager.full_name)
        if (Object.keys(order).length !== 0 && !arrManagers.includes(order.manager.full_name)) {
            arrManagers.push(order.manager.full_name)
        }

        if (Object.keys(order).length !== 0 && !arrSources.length) {
            switch (order.source_id) {
                case 1: arrSources.push("lava.studio.in")
                    break;
                case 2: arrSources.push("telegram")
                    break;
                case 4: arrSources.push("lava_underwear")
                    break;
                case 9: arrSources.push("shopify")
                    break;
                case 10: arrSources.push("шоурум Київ")
                    break;
            }
        } else if (Object.keys(order).length !== 0 && arrSources.length) {
            if (!arrSources.includes("lava.studio.in") && order.source_id === 1)  arrSources.push("lava.studio.in")
            if (!arrSources.includes("telegram") && order.source_id === 2)  arrSources.push("telegram")
            if (!arrSources.includes("lava_underwear") && order.source_id === 4)  arrSources.push("lava_underwear")
            if (!arrSources.includes("shopify") && order.source_id === 9)  arrSources.push("shopify")
            if (!arrSources.includes("шоурум Київ") && order.source_id === 10)  arrSources.push("шоурум Київ")
        }
    })

    const filterByStatus = order => {
        if(Object.keys(order).length !== 0) {
            const isOrderReturns = order.status.id === 20 || order.status.id === 21 || order.status.id === 39
            return order.status.group_id === 1 || order.status.group_id === 3 || order.status.group_id === 4 || order.status.group_id === 5 || isOrderReturns
        }
    }

    const filterWithoutTelegram = order => {
        if(Object.keys(order).length !== 0) {
            return order.source_id !== 2
        }
    }
    const filterByGrandTotal = order => {
        if(Object.keys(order).length !== 0) {
            // if (order.tags.some(t => t.id === 2)) console.log("order.tags.some(t => t.id === 2)", order.tags.some(t => t.id === 2), order)
            return order.grand_total > 0 || order.tags.some(t => t.id === 2) && order.grand_total === 0 // замена с 100% скидкой
        }
    }

    const filterByTags = order => {
        const isNoWholesale = (currentValue) => currentValue.id !== 4 && currentValue.id !== 1; // 1 Бартер 4 Опт
        if(Object.keys(order).length !== 0) {
            return order.tags.every(isNoWholesale)
        }
    }

    // console.log("orders:", orders)

    let sourceMap = {
        "lava.studio.in": 1,
        "telegram": 2,
        "lava_underwear": 4,
        "shopify": 9,
        "шоурум Київ": 10
    };

    let filteredOrders = orders
        .filter(filterByTags)
        .filter(filterByStatus)
        .filter(filterByGrandTotal)
        .filter(order => {
            if (Object.keys(order).length === 0) return false;

            const isManagerMatch = manager === "all" || order.manager.full_name === manager;
            const isSourceMatch = source === "all" || order.source_id === sourceMap[source];

            return isManagerMatch && isSourceMatch;
        });


    // console.log("filteredOrders:", filteredOrders)
    // const www = filteredOrders.filter(o => o.id === 14458)
    // console.log("!!!!!!!!!!!!!!!!!!!!!!", www)

    filteredOrders.forEach((o)=>{
        const names = o.products.map(function(item){
            if(item.name.includes(" - ")) item.name = item.name.split(" - ")[0].trim()
            return item.name
        });
        const isDuplicate = names.some(function(item, idx){
            return names.indexOf(item) != idx
        });

        const arrSuites = []

        //Получаем массив Дублей (товаров больше 1шт) == arrDuplicate
        const lookup = o.products.reduce((a, c) => {
            a[c.name] = ++a[c.name] || 0;
            return a;
        }, {});
        const arrDuplicateOne = o.products.filter(p => lookup[p.name])
        const arrOverOne = o.products.filter(p => p.quantity > 1)
        const arrDuplicate = arrDuplicateOne
            .reduce((accumulator, item2) => {
                if (!accumulator.some(item1 =>
                    item1.id === item2.id)) {
                    accumulator.push(item2);
                }
                return accumulator;
            }, arrOverOne);

        // Получение остальных товаров заказа == arrOthers
        const isSameUser = (a, b) => a.name === b.name && a.sku === b.sku;
        const onlyInLeft = (left, right, compareFunction) =>
            left.filter(leftValue =>
                !right.some(rightValue =>
                    compareFunction(leftValue, rightValue)));

        const onlyInA = onlyInLeft(o.products, arrDuplicate, isSameUser);
        const onlyInB = onlyInLeft(arrDuplicate, o.products, isSameUser);

        const arrOthers = [...onlyInA, ...onlyInB];

        function changeSuitesMarginSum() {
            if(multiSearchAtLeastN(names, "Мастерка,Карго", 2) || multiSearchAtLeastN(names, "Майстерка,Карго", 2)) {
                o.products.forEach((p) => {
                    if (p.name === "Мастерка" || p.name === "Майстерка") p.discount_amount = 150
                    if (p.name === "Карго 2023" || p.name === "Карго") p.discount_amount = 150
                    p.margin_sum = p.price_sold - p.purchased_price - p.discount_amount
                })
            }
            if(multiSearchAtLeastN(names, "Палаццо,Жилет", 2)) {
                o.products.forEach((p) => {
                    if (p.name.includes("Палаццо")) p.discount_amount = 160
                    if (p.name === "Жилет") p.discount_amount = 165
                    p.margin_sum = p.price_sold - p.purchased_price - p.discount_amount
                })
            }
            if(multiSearchAtLeastN(names, "Худі петля,Джогери петля", 2)) {
                o.products.forEach((p) => {
                    if (p.name.includes("Худі петля")) p.discount_amount = 150
                    if (p.name.includes("Джогери петля")) p.discount_amount = 150
                    p.margin_sum = p.price_sold - p.purchased_price - p.discount_amount
                })
            }
            if(multiSearchAtLeastN(names, "Худі Фліс,Джогери Фліс", 2)) {
                o.products.forEach((p) => {
                    if (p.name.includes("Худі Фліс")) p.discount_amount = 150
                    if (p.name.includes("Джогери Фліс")) p.discount_amount = 150
                    p.margin_sum = p.price_sold - p.purchased_price - p.discount_amount
                })
            }
            if(multiSearchAtLeastN(names, "Зіпхуді петля,Джогери петля", 2)) {
                o.products.forEach((p) => {
                    if (p.name.includes("Зіпхуді петля")) p.discount_amount = 100
                    if (p.name.includes("Джогери петля")) p.discount_amount = 100
                    p.margin_sum = p.price_sold - p.purchased_price - p.discount_amount
                })
            }
            if(multiSearchAtLeastN(names, "Зіпхуді Фліс,Джогери Фліс", 2)) {
                o.products.forEach((p) => {
                    if (p.name.includes("Зіпхуді Фліс")) p.discount_amount = 100
                    if (p.name.includes("Джогери Фліс")) p.discount_amount = 100
                    p.margin_sum = p.price_sold - p.purchased_price - p.discount_amount
                })
            }
            if(multiSearchAtLeastN(names, "Світшот петля,Джогери петля", 2)) {
                o.products.forEach((p) => {
                    if (p.name.includes("Світшот петля")) p.discount_amount = 100
                    if (p.name.includes("Джогери петля")) p.discount_amount = 100
                    p.margin_sum = p.price_sold - p.purchased_price - p.discount_amount
                })
            }
            if(multiSearchAtLeastN(names, "Світшот Фліс,Джогери Фліс", 2)) {
                console.log("Світшот Фліс,Джогери Фліс INCLUDES")
                o.products.forEach((p) => {
                    if (p.name.includes("Світшот Фліс")) p.discount_amount = 100
                    if (p.name.includes("Джогери Фліс")) p.discount_amount = 100
                    p.margin_sum = p.price_sold - p.purchased_price - p.discount_amount
                })
            }
        }

        // console.log("arrOthers",o.id,o.products.length, arrOthers);
        // console.log("arrDuplicate", o.id, o.products.length, arrDuplicate);

        function applyDiscount(p, name, discount) {
            if (p.name === name) {
                p.discount_amount = discount;
                if (p.quantity > 1) {
                    p.discount_amount = p.discount_amount * p.quantity;
                }
            }
        }

        if (o.discount_amount === 0) {
            if (o.products.length === 1) {
                o.products[0].margin_sum = o.margin_sum;
            } else {
                o.products.forEach((p) => {
                    p.margin_sum = p.price_sold - p.purchased_price;
                });
            }
        } else {
            if (o.products.length === 1) {
                o.products[0].margin_sum = o.margin_sum;
            } else {
                if (arrDuplicate.length === 0) {
                    o.products.forEach((p) => {
                        p.margin_sum = p.price_sold - p.purchased_price - p.discount_amount;
                    });
                    changeSuitesMarginSum();
                } else {
                    const duplicateCount = {};
                    names.forEach(e => duplicateCount[e] = duplicateCount[e] ? duplicateCount[e] + 1 : 1);
                    const arrDuplicateCount = Object.keys(duplicateCount).map(e => {return {name:e, count:duplicateCount[e]}});

                    o.products.forEach((p) => {
                        arrDuplicateCount.forEach((d) => {
                            // Знижки для дублів товарів
                            applyDiscount(p, "Футболка Двонитка", d.count % 2 === 0 ? 90.5 : 90);
                            applyDiscount(p, "Футболка двонитка", d.count % 2 === 0 ? 90.5 : 90);
                            applyDiscount(p, "Майка", d.count % 2 === 0 ? 50.5 : 50.5);
                            applyDiscount(p, "Труси з рюшами", 49.5);
                            applyDiscount(p, "Комплект білизни", d.count % 2 === 0 ? 100.5 : 67);
                            applyDiscount(p, "Труси SEX&CANDY", 50);

                            if (d.count === 1) {
                                p.discount_amount = 0;
                            }
                        });
                        p.margin_sum = p.quantity * p.price_sold - p.quantity * p.purchased_price - p.discount_amount;
                    });
                }
            }
        }

    })
    // console.log("ordersMarginfiltered:", filteredOrders)
    let sumQ = 0
    let sumM = 0
    let sumT = 0

    const allProductsTest = []
    filteredOrders.forEach((o) => {
        let sumS = 0
        let sumMO = 0
        o.products.forEach((p) => {
            allProductsTest.push(p)
            sumQ += p.quantity
            sumM += p.margin_sum
            sumMO += p.margin_sum
            sumS += p.purchased_price*p.quantity


            // console.log("product:", o.id, p.margin_sum)
            // console.log("product:", o.id, p.margin_sum)
        })
        sumT += o.grand_total
        // console.log("общая стоимость:", o.grand_total)
        // if (o.grand_total - sumS !== sumMO) console.log("Заказ №:", o.id ,"маржа:", o.grand_total - sumS, "===", sumMO)
        // else console.log("Заказ №:", o.id ,"Всё сходится!!!")
        // console.log("новая маржа:", sumMO)
    })

    let grand_total = 0
    let quantityProducts = 0
    let margin_sum = 0
    let numberOfClearanceSales = 0
    let quantityRepeatSales = 0
    let quantityInstagramSales = 0
    let totalUpsale = 0
    let totalGTReturns = 0

    let arrProducts = []

    let totalDataSource = {
        instagram: {
            returns: 0,
            sales: 0,
            grandTotal: 0
        },
        telegram: {
            returns: 0,
            sales: 0,
            grandTotal: 0
        },
        site: {
            returns: 0,
            sales: 0,
            grandTotal: 0
        },
        showroom: {
            returns: 0,
            sales: 0,
            grandTotal: 0
        },
    }


    const getLocaleDate = (utcDate) => {
        const localeDate = new Date(utcDate);
        return localeDate.toLocaleDateString("ru-RU").replace(/\./g, "-");
    };

    const getOrdersByRange = (arr, range) => {

        return arr.reduce((a, c) => {
            let eDate, cDate;
            let idx = a.findIndex((e) => {
                switch (range) {
                    case 'day':
                        eDate = getLocaleDate(e[0].created_at)
                        cDate = getLocaleDate(c.created_at)
                        break;
                    case 'week':
                        eDate = new Date(e[0].created_at).getWeek()
                        cDate = new Date(c.created_at).getWeek()
                        break;
                    case '2weeks':
                        eDate = new Date(e[0].created_at).get2Weeks()
                        cDate = new Date(c.created_at).get2Weeks()
                        break;
                    case 'month':
                        eDate = new Date(e[0].created_at).getMonth()
                        cDate = new Date(c.created_at).getMonth()
                        break;
                    case 'year':
                        eDate = new Date(e[0].created_at).getFullYear()
                        cDate = new Date(c.created_at).getFullYear()
                        break;
                }
                return eDate === cDate
            });
            if (idx !== -1) a[idx].push(c);
            else a.push([c]);
            return a;
        }, []);
    }
    let ranges = {}
    ranges.spend = []
    ranges.clicks = []
    ranges.ranges = getOrdersByRange(filteredOrders, rangeDate)


    filteredOrders.forEach(order => {
        const isOrderReturns = order.status.id === 20 || order.status.id === 21 || order.status.id === 39
        grand_total = grand_total + order.grand_total
        totalGTReturns = isOrderReturns ? totalGTReturns + order.grand_total : totalGTReturns

        margin_sum = margin_sum + order.margin_sum
        if (order.tags.length !== 0) {
            order.tags.forEach(tag => {
                if (tag.id === 5) return quantityRepeatSales++
                if (tag.id === 6) return numberOfClearanceSales++
                if (tag.id === 6) return quantityInstagramSales++
            })
        }

        getDataSource(order, totalDataSource.instagram, 1, 4)
        getDataSource(order, totalDataSource.telegram, 2)
        getDataSource(order, totalDataSource.site, 9)
        getDataSource(order, totalDataSource.showroom, 10)


        order.products.forEach(product => {
            totalUpsale = product.upsale ? totalUpsale + 1 : totalUpsale
            quantityProducts = quantityProducts + product.quantity
            arrProducts.push({name: product.name, quantity: product.quantity, margin_sum: product.margin_sum})
        })
    })
    let productsAllOfPeriod = arrProducts.reduce((a, c) => {
        let idx = a.findIndex((e) => e.name === c.name);
        if (idx === -1) a.push(c)
        else {
            a[idx].quantity = a[idx].quantity + c.quantity
            a[idx].margin_sum = a[idx].margin_sum + c.margin_sum
        }
        return a;
    }, []);

    productsAllOfPeriod.sort(sortProducts)

    const onFilterValueSelected = filterValue => setSource(filterValue)
    const onManagerSelected = manager => setManager(manager)
    const onRangeSelected = range => setRangeDate(range)
    const handleChangeUpLoading = () => setUploadData(!isUploadData);
    const handleChangeHours = () => setEveningShiftHours(!eveningShiftHours);
    const handleHideMargin = () => setHideMargin(!hideMargin);

    const addDataToDB = async (parameters) => {
        await handleRemoveData()
        const data = await fetchDataForDB(parameters)
        const dataDB = data.filter(filterByStatus).filter(filterByTags).filter(filterByGrandTotal).filter((order) => {
            if(Object.keys(order).length !== 0) return order.source_id === 1 || order.source_id === 2 || order.source_id === 4 || order.source_id === 9 || order.source_id === 10
        })
        // const dataDBU = data.filter(filterByStatus).filter(filterByTags).filter(filterByGrandTotal).filter((order) => {
        //     if(Object.keys(order).length !== 0) return order.source_id === 4
        //     if(Object.keys(order).length !== 0) return order.source_id === 4
        // })
        let rangesDB = getOrdersByRange(dataDB,'day')
        // let rangesDBU = getOrdersByRange(dataDBU,'day')
        const result = rangesDB.map((day, i) => {
            let grand_total = 0
            let quantityProducts = 0
            let margin_sum = 0
            let numberOfClearanceSales = 0
            let quantityRepeatSales = 0
            let arr = []
            let quantityUpsale = 0
            let total_returns = 0
            let grand_total_returns = 0
            let instagram = {
                grandTotal: 0, returns: 0, sales: 0
            }
            let telegram = {
                grandTotal: 0, returns: 0, sales: 0
            }
            let site = {
                grandTotal: 0, returns: 0, sales: 0
            }
            let showroom = {
                grandTotal: 0, returns: 0, sales: 0
            }

            day.forEach(order => {

                const isOrderReturns = order.status.id === 20 || order.status.id === 21 || order.status.id === 39
                grand_total = grand_total + order.grand_total
                total_returns = isOrderReturns ? total_returns + 1 : total_returns
                grand_total_returns = isOrderReturns ? grand_total_returns + order.grand_total : grand_total_returns

                margin_sum = margin_sum + order.margin_sum
                totalMarginOfRange = margin_sum

                getDataSource(order, instagram, 1, 4)
                getDataSource(order, telegram, 2)
                getDataSource(order, site, 9)
                getDataSource(order, showroom, 10)

                if (order.tags.length !== 0) {
                    order.tags.forEach(tag => {
                        if (tag.id === 5) return quantityRepeatSales++
                        if (tag.id === 6) return numberOfClearanceSales++
                    })
                }

                order.products.forEach(product => {
                    quantityUpsale = product.upsale ? quantityUpsale + 1 : quantityUpsale
                    quantityProducts = quantityProducts + product.quantity
                    arr.push({name: product.name, quantity: product.quantity})
                })
            })

            let productsDay = arr.reduce((a, c) => {
                let idx = a.findIndex((e) => e.name === c.name);
                if (idx === -1) a.push(c)
                else a[idx].quantity = a[idx].quantity + c.quantity
                return a;
            }, []);
            productsDay = getCustomNames(productsDay, "quantity")
            // console.log("productsDay:", productsDay)
            return {
                date: day[0].created_at,
                dateLocal: getLocaleDate(day[0].created_at),
                quantityOrders: day.length,
                quantityRepeatSales,
                numberOfClearanceSales,
                grand_total: Math.floor(grand_total),
                margin_sum: Math.floor(margin_sum),
                quantityProducts,
                productsDay,
                quantityUpsale,
                total_returns,
                grand_total_returns,
                instagram,
                telegram,
                site,
                showroom
            }
        });
        // const resultU = rangesDBU.map((day, i) => {
        //     let grand_total = 0
        //     let quantityProducts = 0
        //     let margin_sum = 0
        //     let numberOfClearanceSales = 0
        //     let quantityRepeatSales = 0
        //     let arr = []
        //
        //     day.forEach(order => {
        //         grand_total = grand_total + order.grand_total
        //         margin_sum = margin_sum + order.margin_sum
        //
        //         if (order.tags.length !== 0) {
        //             order.tags.forEach(tag => {
        //                 if (tag.id === 5) return quantityRepeatSales++
        //                 if (tag.id === 6) return numberOfClearanceSales++
        //             })
        //         }
        //
        //         order.products.forEach(product => {
        //             quantityProducts = quantityProducts + product.quantity
        //             arr.push({name: product.name, quantity: product.quantity})
        //         })
        //     })
        //
        //     let productsDay = arr.reduce((a, c) => {
        //         let idx = a.findIndex((e) => e.name === c.name);
        //         if (idx === -1) a.push(c)
        //         else a[idx].quantity = a[idx].quantity + c.quantity
        //         return a;
        //     }, []);
        //     productsDay = getCustomNames(productsDay, "quantity")
        //     // console.log("productsDay:", productsDay)
        //     return {
        //         date: day[0].created_at,
        //         dateLocal: getLocaleDate(day[0].created_at),
        //         quantityOrders: day.length,
        //         quantityRepeatSales: quantityRepeatSales,
        //         numberOfClearanceSales: numberOfClearanceSales,
        //         grand_total: Math.floor(grand_total),
        //         margin_sum: Math.floor(margin_sum),
        //         quantityProducts: quantityProducts,
        //         productsDay: productsDay
        //     }
        // });
        await fetch('/api/orders', {
            method: "DELETE",
            headers: {
                'Content-Type': 'application/json;charset=utf-8'
            },
            body: JSON.stringify({})})
        await fetch('/api/orders', {
            method: "POST",
            headers: {
                'Content-Type': 'application/json;charset=utf-8'
            },
            body: JSON.stringify(result)
        }
        )
        // await fetch('/api/u_orders', {
        //     method: "POST",
        //     headers: {
        //         'Content-Type': 'application/json;charset=utf-8'
        //     },
        //     body: JSON.stringify(resultU)
        // }
        // )
    }
    const handleAddData = async () => {
        addDataToDB(parametersDB)
    }

    const handleAddPrevDay = () => {
        addDataToDB(parametersPrevDay)
    }
    const handleAddCurrentMonth = () => {
        addDataToDB(parametersCurrentMonth)
        return setLoadingCM(true)
    }
    const handleAddPrevMonth = () => {
        addDataToDB(parametersPrevMonth)
        return setLoadingPM(true)
    }
    async function handleRemoveData() {
        await fetch('/api/orders', {
            method: "DELETE",
            headers: {
                'Content-Type': 'application/json;charset=utf-8'
            },
            body: JSON.stringify({})})
        // await fetch('/api/u_orders', {
        //     method: "DELETE",
        //     headers: {
        //         'Content-Type': 'application/json;charset=utf-8'
        //     },
        //     body: JSON.stringify({})})
        await console.log("DELETED!")
    }

    let sumSpend = 0
    let sumSpendRed = 0
    let sumQuantityGeen = 0

    let sumMargin = 0
    let productsFB = []

    const dailyDataFromFB = dataFB.map(day => {   // массив дней где day єто object
        const dataAnalitics = []  // массив прорекламированних товаров
        let sumSpendFB = 0  // потрачений дневной бюджет
        let sumClicksFB = 0 // количество кликов за день

        day.ads.forEach(ad => { // массив реклам за день
            let names = ad.campaign_name.replace(/\s*\([^)]*\)/g, '').replace(/  +/g, ' ');
            const products = names.split(",").map(product => product.trim());
            const spend = +ad.spend
            const clicks = +ad.clicks
            sumSpendFB = sumSpendFB + spend
            sumClicksFB = sumClicksFB + clicks
            products.forEach((product, i)=> {
                //
                dataAnalitics.push({name: product.trim(), spend: +(parseFloat(spend)/products.length).toFixed(2), clicks: clicks/products.length})
            })
        })
        let arrProductsFB = dataAnalitics.reduce((a, c) => {
            let idx = a.findIndex((e) => e.name.toLowerCase() === c.name.toLowerCase());
            if (idx !== -1 && a.length !== 0 && a[idx].name.toLowerCase() === c.name.toLowerCase()) {
                a[idx].spend = +(a[idx].spend + c.spend).toFixed(2)
                a[idx].clicks = a[idx].clicks + c.clicks
            } else a.push(c);
            return a;
        }, []).sort(sortNames);
        arrProductsFB.forEach((p)=>{
            productsFB.push({name: p.name, spend: p.spend, clicks: p.clicks})
        })
        return {date: day.date, spend: sumSpendFB.toFixed(2), clicks: sumClicksFB, productsOnAds: arrProductsFB}
    })
    // console.log("dailyDataFromFB:", dailyDataFromFB)
    // console.log("productsFB:", productsFB)
    let productsAllOfPeriodFB = productsFB.reduce((a, c) => {
        let idx = a.findIndex((e) => e.name === c.name);
        if (idx === -1) a.push(c)
        else a[idx].spend = +(a[idx].spend + c.spend).toFixed(2)
        return a;
    }, []);


    productsAllOfPeriodFB = getCustomNames(productsAllOfPeriodFB, "spend", "clicks")
    productsAllOfPeriod = getCustomNames(productsAllOfPeriod, "quantity", "margin_sum")



    productsAllOfPeriodFB.map((p1, i) => {
        const spend$ = p1.spend
        productsAllOfPeriod.map((p2, i) => {
            const quantity = p2.quantity
            sumMargin += (p2.margin_sum / 41)
            if(p1.name.toLowerCase() === p2.name.toLowerCase()) {
                const margin$ = p2.margin_sum / 41
                p1.grade = +(margin$/spend$*(margin$ - spend$)/quantity).toFixed()
                p1.payback = +(p2.margin_sum / 41/spend$).toFixed(2)
                p1.margin$ = p2.margin_sum / 41
            }
        })
    })
    const uploadVariantsArr = [...productsAllOfPeriodFB, ...productsAllOfPeriod]

    let uploadArr = uploadVariantsArr.reduce((a, c) => {
        let idx = a.findIndex((e) => e.name === c.name);
        if (idx === -1) {
            if (!c.hasOwnProperty("quantity")) c.quantity = 0
            if (!c.hasOwnProperty("spend")) c.spend = 0
            if (!c.hasOwnProperty("payback")) c.payback = 0
            if (!c.hasOwnProperty("grade")) c.grade = 0
            if (!c.hasOwnProperty("clicks")) c.clicks = 0
            if (!c.hasOwnProperty("margin_sum")) c.margin_sum = 0
            if (!c.hasOwnProperty("margin$")) c.margin$ = 0
            a.push(c)
        } else {
            a[idx] = {...a[idx], ...c}
        }
        return a;
    }, []);

    // console.log("uploadArr:", uploadArr)

    const uploadArrRed = uploadArr.filter(p => p.quantity === 0)

    const uploadArrGreen = uploadArr.filter(p => p.spend === 0)


    productsAllOfPeriodFB.sort(sortHeaderUploadData);


    // A comparer used to determine if two entries are equal.
    const isSameUser = (a, b) => a.name === b.name

// Get items that only occur in the left array,
// using the compareFunction to determine equality.
    const onlyInLeft = (left, right, compareFunction) =>
        left.filter(leftValue =>
            !right.some(rightValue =>
                compareFunction(leftValue, rightValue)));



    let countProductsOfRange = 0
    let totalMarginOfRange = 0
    const ordersForUpload = filteredOrders.filter(filterWithoutTelegram).filter(order => !(order.tags.some(t => t.id === 2) && order.grand_total === 0 ))

    // объект с данными менеджеров
    const managersStaticData = {
        // 7: { name: "Анна Смирнова", percent: 0.05, baseSalary: 50000 },
        // 17: { name: "Дмитро Коток", percent: 0.05, baseSalary: 20000 },
        // 18: { name: "Владислав Костін", percent: 0.05, baseSalary: 10000 },
        5: { name: "Ліка Ріц", percent: 0.03, baseSalary: 0 },
        6: { name: "Анна Каменева", percent: 0.03, baseSalary: 0 },
        11: { name: "Кристина Шляхова", percent: 0.03, baseSalary: 0 },
        // 13: { name: "Карина Светличная", percent: 0.05, baseSalary: 20000 },
        // 16: { name: "Єлизавета Савченко", percent: 0.05, baseSalary: 0 }
    };


    const validOrders = Array.isArray(orders)
        ? orders.filter(order =>
            ([1, 3, 4, 5].includes(order.status?.group_id) ||
                [20, 21, 39].includes(order.status?.id)) &&
            (order.grand_total > 0 || (order.grand_total === 0 && order.tags.some(t => t.id === 2))) &&
            !order.tags.some(t => t.id === 4) // Исключаем заказы с тегом id = 4
        )
        : [];

    const groupedOrders = validOrders.length > 0
        ? Object.entries(
            validOrders.reduce((acc, order) => {
                const managerId = order.manager?.id;
                if (!managerId || !managersStaticData[managerId]) return acc;

                const { name: managerName, percent, baseSalary } = managersStaticData[managerId];

                if (managerId === 7) { // Фильтр для Анны Смирновой
                    const hasWholesaleTag = Array.isArray(order.tags) && order.tags.some(tag => tag.id === 4);
                    if (!hasWholesaleTag) return acc;
                }

                if (!acc[managerId]) {
                    acc[managerId] = {
                        managerId: Number(managerId),
                        manager: managerName,
                        orders: [],
                        turnover: 0,
                        salesCount: 0,
                        averageCheck: 0,
                        upsellCount: 0,
                        failedOrdersCount: 0,
                        percent,
                        baseSalary,
                        salary: 0,
                        returnRate: 0,
                        leads: leads[managerId] || 0, // Подставляем актуальные лиды
                        conversionRate: 0
                    };
                }

                acc[managerId].orders.push(order);
                acc[managerId].turnover += Math.floor(order.grand_total || 0);
                acc[managerId].salesCount += 1;

                const upsaleProducts = Array.isArray(order.products)
                    ? order.products.filter(product => product.upsale)
                    : [];
                acc[managerId].upsellCount += upsaleProducts.length;

                const isOrderReturns = [20, 21, 39].includes(order.status?.id);
                if (isOrderReturns) {
                    acc[managerId].failedOrdersCount += 1;
                }

                return acc;
            }, {})
        ).map(([managerId, data]) => ({
            ...data,
            averageCheck: data.salesCount ? Math.floor(data.turnover / data.salesCount) : 0,
            salary: Math.floor(data.turnover * data.percent + data.baseSalary),
            returnRate: data.salesCount > 0
                ? Number(((data.failedOrdersCount / data.salesCount) * 100).toFixed(2))
                : 0,
            conversionRate: data.leads > 0
                ? Number(((data.salesCount / data.leads) * 100).toFixed(2))
                : 0
        }))
        : [];



    console.log("groupedOrders:", groupedOrders);




    return (<>
        <header className="header-orders">
            <div className="section-controls">
                <p>Updated at <strong>{timeLastUpdated}</strong></p>
                <InputGroup className="mb-3">
                <div className="holder-datapickers">
                    <DatePicker dateFormat="dd.MM.yyyy" locale="uk" selected={range.startDate} onChange={date => setRange(prevRange => ({ ...prevRange, startDate : date }))} />
                    <DatePicker dateFormat="dd.MM.yyyy" locale="uk" selected={range.endDate} onChange={date => setRange(prevRange => ({ ...prevRange, endDate : date }))}  />
                </div>
                </InputGroup>
                <InputGroup className="mb-3">
                <Button
                    variant="outline-dark"
                    disabled={isLoading}
                    onClick={!isLoading ? handleClickCreate : null}
                >
                    {isLoading ? 'Loading…' : 'Створити'}
                </Button>
                <Button
                    variant="outline-dark"
                    onClick={!isLoadingT ? handleClickToday : null}
                >
                    {isLoadingT ? 'Loading…' : 'Сьогодні'}
                </Button>
                <Button
                    variant="outline-dark"
                    onClick={!isLoadingY ? handleClickYestarday : null}
                >
                    {isLoadingY ? 'Loading…' : 'Вчора'}
                </Button>
                    <AppCheckbox
                        id="dashboard-plan-completed"
                        className="text-lg"
                        label="План виконано"
                        checked={planCompleted}
                        onChange={() => setPlanCompleted((prev) => !prev)}
                    />
            </InputGroup>
            <InputGroup className="mb-3">
                    <FilterOrder options={arrSources} filterValueSelected={onFilterValueSelected}/>
                    <FilterOrder options={arrManagers} filterValueSelected={onManagerSelected}/>
                    <FilterOrder options={arrRanges} filterValueSelected={onRangeSelected}/>
                </InputGroup>
            </div>
        </header>
        <main>
            <div className="container-fluid px-0">
                <section className="section-table">
                    <div className="holder-table">
                        <table className="table table-orders table-bordered table-striped">
                            <thead className="stiky header-table">
                            <tr>
                                {
                                    <>
                                        <th>дата</th>
                                        <th>Кількість замовлень</th>
                                        <th>Кількість Instagram</th>
                                        <th>Кількість Telegram</th>
                                        <th>Кількість Site</th>
                                        <th>Кількість Showroom</th>
                                        <th>Кількість повторних продажів, шт.</th>
                                        <th>Кількість замовлень з SALE, шт.</th>
                                        <th>Загальна вартість, грн.</th>
                                        {!hideMargin && <th>Маржа, грн.</th>}
                                        <th>ТО <br/> Instagram</th>
                                        <th>ТО <br/> Telegram</th>
                                        <th>ТО <br/> Site</th>
                                        <th>ТО <br/> Showroom</th>
                                        <th>ТО <br/> повернень</th>
                                        <th>Кількість повернень</th>
                                        <th>Повернення <br/> Instagram</th>
                                        <th>Повернення <br/> Telegram</th>
                                        <th>Повернення <br/> Site</th>
                                        <th>Повернення <br/> Showroom</th>
                                        <th>Зарплата, грн.</th>
                                        <th>Середній чек, грн.</th>
                                        <th>Кількість допродажів</th>
                                        <th>Кількість товарів, шт.</th>
                                        {productsAllOfPeriod.map((p, i) => <th className="product-name" key={i}>{p.name}</th>)}
                                    </>
                                }
                            </tr>
                            </thead>
                            <tbody>
                            {ranges.ranges.map((range, i) => {
                                let grand_total = 0
                                let quantityProducts = 0
                                let quantityUpsale = 0
                                let margin_sum = 0
                                let numberOfClearanceSales = 0
                                let quantityRepeatSales = 0
                                let total_returns = 0
                                let grand_total_returns = 0
                                let instagram = {
                                    grandTotal: 0, returns: 0, sales: 0
                                }
                                let telegram = {
                                    grandTotal: 0, returns: 0, sales: 0
                                }
                                let site = {
                                    grandTotal: 0, returns: 0, sales: 0
                                }
                                let showroom = {
                                    grandTotal: 0, returns: 0, sales: 0
                                }
                                let arr = []
                                countProductsOfRange = range.length

                                range.forEach(order => {
                                    const isOrderReturns = order.status.id === 20 || order.status.id === 21 || order.status.id === 39
                                    grand_total = grand_total + order.grand_total
                                    total_returns = isOrderReturns ? total_returns + 1 : total_returns
                                    grand_total_returns = isOrderReturns ? grand_total_returns + order.grand_total : grand_total_returns

                                    margin_sum = margin_sum + order.margin_sum
                                    totalMarginOfRange = margin_sum

                                    getDataSource(order, instagram, 1, 4)
                                    getDataSource(order, telegram, 2)
                                    getDataSource(order, site, 9)
                                    getDataSource(order, showroom, 10)

                                    if (order.tags.length !== 0) {
                                        order.tags.forEach(tag => {
                                            if (tag.id === 5) return quantityRepeatSales++
                                            if (tag.id === 6) return numberOfClearanceSales++
                                        })
                                    }

                                    order.products.forEach(product => {
                                        quantityUpsale = product.upsale ? quantityUpsale + 1 : quantityUpsale
                                        quantityProducts = quantityProducts + product.quantity
                                        arr.push({name: product.name, quantity: product.quantity})
                                    })
                                })

                                let productsDay = arr.reduce((a, c) => {
                                    let idx = a.findIndex((e) => e.name === c.name);
                                    if (idx === -1) a.push(c)
                                    else a[idx].quantity = a[idx].quantity + c.quantity
                                    return a;
                                }, []);

                                productsDay = getCustomNames(productsDay, "quantity")

                                return <tr key={i} className="day-data">
                                    <td className="first-cell">{getLocaleDate(range[0].created_at)}</td>
                                    <td>{range.filter(order => order.status.id !== 39).length}</td>
                                    <td>{instagram.sales}</td>
                                    <td>{telegram.sales}</td>
                                    <td>{site.sales}</td>
                                    <td>{showroom.sales}</td>
                                    <td>{quantityRepeatSales}</td>
                                    <td>{numberOfClearanceSales}</td>
                                    <td>{Math.floor(grand_total)}</td>
                                    {!hideMargin && <td>{Math.floor(margin_sum)}</td>}
                                    <td>{instagram.grandTotal}</td>
                                    <td>{telegram.grandTotal}</td>
                                    <td>{site.grandTotal}</td>
                                    <td>{showroom.grandTotal}</td>
                                    <td>{Math.floor(grand_total_returns)}</td>
                                    <td>{total_returns}</td>
                                    <td>{instagram.returns}</td>
                                    <td>{telegram.returns}</td>
                                    <td>{site.returns}</td>
                                    <td>{showroom.returns}</td>
                                    <td>{+(Math.floor(grand_total * 0.04)).toFixed(0)}</td>
                                    <td>{Math.floor(grand_total/range.length)}</td>
                                    <td>{quantityUpsale}</td>
                                    <td>{quantityProducts}</td>
                                    {productsAllOfPeriod.map((valueTh, ith) => {
                                        let quantity = ""
                                        productsDay.forEach((p, pi) => {
                                            if (valueTh.name === p.name) {
                                                quantity = p.quantity
                                            }
                                        })
                                        return <td key={ith}>{quantity}</td>
                                    })}
                                </tr>
                            })}
                            </tbody>
                            {ranges.ranges.length > 1 && <tfoot>
                            <tr className="day-data">
                                <td className="first-cell"><strong>Взагалом</strong></td>
                                <td><strong>{filteredOrders.filter(order => order.status.id !== 39).length}</strong></td> {/*Убираю дубль-заказ частичного возврата при подсчете заказов*/}
                                <td>{totalDataSource.instagram.sales}</td>
                                <td>{totalDataSource.telegram.sales}</td>
                                <td>{totalDataSource.site.sales}</td>
                                <td>{totalDataSource.showroom.sales}</td>
                                <td><strong>{quantityRepeatSales}</strong></td>
                                <td><strong>{numberOfClearanceSales}</strong></td>
                                <td><strong>{Math.floor(grand_total)}</strong></td>
                                {!hideMargin && <td><strong>{Math.floor(margin_sum)}</strong></td>}
                                <td>{totalDataSource.instagram.grandTotal}</td>
                                <td>{totalDataSource.telegram.grandTotal}</td>
                                <td>{totalDataSource.site.grandTotal}</td>
                                <td>{totalDataSource.showroom.grandTotal}</td>
                                <td>{Math.floor(totalGTReturns)}</td>
                                <td>{totalDataSource.instagram.returns+totalDataSource.telegram.returns+totalDataSource.site.returns+totalDataSource.showroom.returns}</td>
                                <td>{totalDataSource.instagram.returns}</td>
                                <td>{totalDataSource.telegram.returns}</td>
                                <td>{totalDataSource.site.returns}</td>
                                <td>{totalDataSource.showroom.returns}</td>
                                <td><strong>{+(Math.floor(grand_total * 0.04)).toFixed(0)}</strong></td>
                                <td><strong>{Math.floor(grand_total/filteredOrders.length)}</strong></td>
                                <td><strong>{totalUpsale}</strong></td>
                                <td><strong>{quantityProducts}</strong></td>
                                {productsAllOfPeriod.map((p, i) => <td key={i}><strong>{p.quantity}</strong></td>)}
                            </tr>
                            </tfoot>}
                        </table>
                    </div>
                    <p style={{padding: "0 15px 15px", position: "relative"}}>продажів на годину - {+(countProductsOfRange/workHours).toFixed(1)}</p>
                   </section>
                {!!groupedOrders && <ManagerTable groupedOrders={groupedOrders} planCompleted={planCompleted} leads={leads} onLeadsChange={handleLeadsChange}  />}
               </div>
        </main></>

    );
}